module.exports = __webpack_public_path__ + "static/media/error-gradient.7b32890f.webp";